import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { COACH_CONFIG } from '../../coachconfig';

const PaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [session, setSession] = useState(null);
  const [error, setError] = useState('');
  const [giftSubmitted, setGiftSubmitted] = useState(false);

  useEffect(() => {
    const sessionId = searchParams.get('session_id');
    if (!sessionId) {
      setError('No session ID found.');
      setLoading(false);
      return;
    }
    setSession(sessionId);

    // Try to submit the gift if pendingGift exists
    const pendingGift = localStorage.getItem('pendingGift');
    if (pendingGift) {
      const giftData = JSON.parse(pendingGift);
      fetch(`${COACH_CONFIG.apiBaseUrl}/gifts`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(giftData)
      })
        .then(res => res.json())
        .then(data => {
          if (data.success) {
            setGiftSubmitted(true);
            localStorage.removeItem('pendingGift');
          } else {
            setError(data.error || 'Gift notification failed.');
          }
        })
        .catch(() => setError('Gift notification failed.'));
    }
    setLoading(false);
  }, [searchParams]);

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <Header />
      <main className="flex-grow flex flex-col items-center justify-center py-20 px-4">
        {loading ? (
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-500 mx-auto mb-4"></div>
            <p className="text-gray-600 text-lg">Processing your payment...</p>
          </div>
        ) : error ? (
          <div className="text-center max-w-md mx-auto">
            <div className="bg-red-50 border border-red-200 rounded-2xl p-8 mb-6">
              <div className="text-4xl mb-4">❌</div>
              <h2 className="text-2xl font-bold text-red-600 mb-4">Payment Error</h2>
              <p className="text-red-700">{error}</p>
            </div>
            <a 
              href="/" 
              className="inline-block bg-gradient-to-r from-purple-600 to-purple-700 hover:from-purple-700 hover:to-purple-800 text-white font-bold py-3 px-6 rounded-xl transition duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl"
            >
              Return to Home
            </a>
          </div>
        ) : (
          <div className="text-center max-w-2xl mx-auto">
            {/* Success Animation Container */}
            <div className="bg-white border border-purple-200 rounded-3xl p-12 mb-8 shadow-2xl">
              {/* Animated Success Icon */}
              <div className="mx-auto w-24 h-24 bg-gradient-to-r from-purple-600 to-purple-700 rounded-full flex items-center justify-center mb-8 animate-pulse">
                <div className="text-4xl">🎉</div>
              </div>
              
              {/* Success Title */}
              <h1 className="text-4xl font-bold text-gray-900 mb-6">
                Payment Successful! ✨
              </h1>
              
              {/* Success Message */}
              <div className="space-y-4 mb-8">
                <p className="text-xl text-gray-600">
                  Thank you for your purchase! Your payment was successful.
                </p>
                {giftSubmitted && (
                  <div className="bg-green-50 border border-green-200 rounded-xl p-4">
                    <p className="text-green-700 font-semibold">
                      🎁 Gift notification sent successfully!
                    </p>
                    <p className="text-green-600 text-sm mt-1">
                      Check your email for confirmation details.
                    </p>
                  </div>
                )}
              </div>
              
              {/* Celebration Emojis */}
              <div className="flex justify-center space-x-3 mb-8">
                <span className="text-3xl animate-bounce" style={{ animationDelay: '0ms' }}>🎉</span>
                <span className="text-3xl animate-bounce" style={{ animationDelay: '100ms' }}>💜</span>
                <span className="text-3xl animate-bounce" style={{ animationDelay: '200ms' }}>✨</span>
                <span className="text-3xl animate-bounce" style={{ animationDelay: '300ms' }}>🎁</span>
                <span className="text-3xl animate-bounce" style={{ animationDelay: '400ms' }}>💪</span>
              </div>
            </div>
            
            {/* Action Buttons */}
            <div className="space-y-4">
              <a 
                href="/" 
                className="inline-block bg-gradient-to-r from-purple-600 to-purple-700 hover:from-purple-700 hover:to-purple-800 text-white font-bold py-4 px-8 rounded-xl transition duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl"
              >
                Return to Home 🏠
              </a>
              
              {giftSubmitted && (
                <div className="text-sm text-gray-500 mt-4">
                  <p>Your gift recipient will be notified shortly! 📧</p>
                </div>
              )}
            </div>
          </div>
        )}
      </main>
      <Footer />
    </div>
  );
};

export default PaymentSuccess; 